// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__NCgOW","links":"Footer_links__R2EZn"};